import { lazy } from 'react';

import { LazyLoad } from '@/shared/ui';

export const MhsDocumentRoute = LazyLoad(
  lazy(() => import('./mhs-document').then((module) => ({ default: module.MhsDocument }))),
);
